module.exports = __webpack_public_path__ + "static/lures-f5a9e4ed5cd0d9c45cc31e23594aeb9a.pdf";